import React, { useEffect } from "react";
import "./App.css";
import Home from "./pages/Home";
import { useDispatch } from "react-redux";
import { fetchAllMessageNotificationsAsync } from "./features/msgNotification/msgNotificationSlice";
import { fetchAllBalanceAsync } from "./features/balance/balanceSlice";
import { fetchAllUpcomingPaymentAsync } from "./features/upcomingPayment/upcomingPaymentSlice";
import { fetchAllSavingCardAsync } from "./features/savingCard/savingCardSlice";
import { fetchAllBeneficiariesAsync } from "./features/beneficiaries/beneficiariesSlice";
import { fetchAllRecentTransactionsAsync } from "./features/recentTransactions/recentTransactionSlice";
import { fetchAllFavCreditCardAsync } from "./features/favCreditCard/favCreditCardSlice";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAllMessageNotificationsAsync());
    dispatch(fetchAllBalanceAsync());
    dispatch(fetchAllUpcomingPaymentAsync());
    dispatch(fetchAllSavingCardAsync());
    dispatch(fetchAllBeneficiariesAsync());
    dispatch(fetchAllRecentTransactionsAsync());
    dispatch(fetchAllFavCreditCardAsync());
  }, []);
  return (
    <div className="">
      <Home />
    </div>
  );
}

export default App;
